var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "div",
        { staticClass: "join-message" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("JoinDialog.NewCustomer")))]),
          _vm._v(" "),
          _c("p", {
            domProps: { innerHTML: _vm._s(_vm.$t("JoinDialog.Text")) }
          }),
          _vm._v(" "),
          _vm.brandKey === "rw" || _vm.brandLayout === "generic"
            ? _c("p", { staticClass: "text_21" }, [
                _vm._v(_vm._s(_vm.$t("JoinDialog.Text_21")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "primary-btn-blue",
              on: {
                click: function($event) {
                  return _vm.closeJoinDialog()
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("JoinDialog.Ok")))])]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91699d0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91699d0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/PopupJoinDialog.vue
// module id = null
// module chunks = 